import EditContentBlock from './EditContentBlock';

export default EditContentBlock;
